import { toValue } from 'vue'

import type { ComponentPublicInstance, MaybeRefOrGetter } from 'vue'

/**
 * Types
 */
export type MaybeElement =
  | HTMLElement
  | SVGElement
  | ComponentPublicInstance
  | undefined
  | null
export type MaybeComputedElementRef<T extends MaybeElement = MaybeElement> =
  MaybeRefOrGetter<T>
type UnRefElementReturn<T extends MaybeElement = MaybeElement> =
  T extends ComponentPublicInstance
    ? Exclude<MaybeElement, ComponentPublicInstance>
    : T | undefined

/**
 * ref から要素を取得する
 */
export const unrefElement = <T extends MaybeElement>(
  elRef: MaybeComputedElementRef<T>,
): UnRefElementReturn<T> => {
  const plain = toValue(elRef)
  return (plain as ComponentPublicInstance)?.$el ?? plain
}
